import React from 'react';
import PropTypes from 'prop-types';
import styles from './ScheduleFilters.module.scss';
import Icon from '../../../../components/icon/Icon';
import Button from '../../../../components/button/Button';
import FilterGroup from '../../../../components/filterGroup/FilterGroup';

const ScheduleFilters = ({
  activeTab,
  setActiveTab,
  dateRangeText,
  onPrevWeek,
  onNextWeek,
  filterCategories,
  filters,
  onFiltersChange,
  onExport,
  hasRotation = false
}) => {
  const tabs = [
    { id: 'student', label: 'Student' },
    { id: 'clinical-site', label: 'Clinical Site' },
    { id: 'specialty', label: 'Speciality' },
  ];

  return (
    <div className={styles.filtersContainer}>
      <div className={styles.leftSection}>
        <div className={styles.tabsMenu}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <FilterGroup
          categories={filterCategories}
          filters={filters}
          onChange={onFiltersChange}
        />
      </div>

      {hasRotation && (
        <div className={styles.centerSection}>
          <button className={styles.iconButton} onClick={onPrevWeek}>
            <Icon name="chevron" />
          </button>
          <div className={styles.dateRange}>{dateRangeText}</div>
          <button className={`${styles.iconButton} ${styles.rotated}`} onClick={onNextWeek}>
            <Icon name="chevron" />
          </button>
        </div>
      )}

      <div className={styles.rightSection}>
        <Button
          label={
            <div className={styles.exportButtonLabel}>
              <Icon name="arrow-up-right" />
              <span className={styles.exportButtonText}>Export View</span>
            </div>
          }
          variant="primary-light"
          size="small"
          onClick={onExport}
          disabled={!hasRotation}
        />
      </div>
    </div>
  );
};

ScheduleFilters.propTypes = {
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  dateRangeText: PropTypes.string,
  onPrevWeek: PropTypes.func,
  onNextWeek: PropTypes.func,
  filterCategories: PropTypes.array,
  filters: PropTypes.object,
  onFiltersChange: PropTypes.func,
  onExport: PropTypes.func,
  hasRotation: PropTypes.bool,
};

export default ScheduleFilters;
